// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
function use(param) {
  var match = React.useState(function () {
    return /* Closed */0;
  });
  var setState = match[1];
  var stateRef = React.useRef(/* Closed */0);
  var handleChange = function (next) {
    Curry._1(setState, function (param) {
      return next;
    });
    stateRef.current = next;
  };
  var onClose = function (param) {
    handleChange(/* Closed */0);
  };
  var onOpen = function (param) {
    handleChange(/* Open */2);
  };
  var onOpening = function (param) {
    handleChange(/* Opening */1);
  };
  return {
    state: match[0],
    stateRef: stateRef,
    onOpening: onOpening,
    onOpen: onOpen,
    onClose: onClose
  };
}
var context = React.createContext(/* Closed */0);
var provider = context.Provider;
function DrawerState$Provider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
    value: value,
    children: children
  });
}
DrawerState$Provider.displayName = "DrawerState.Provider";
function use$1(param) {
  return React.useContext(context);
}
var Provider = {
  context: context,
  provider: provider,
  make: DrawerState$Provider,
  use: use$1
};
export { use, Provider };
/* context Not a pure module */